import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { catchError, Observable, of } from 'rxjs';
import { OrganizationService, PublicInfo } from '@state/organization';
import { Injectable, inject } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PublicInfoResolver {
  private router = inject(Router);
  private organizationService = inject(OrganizationService);

  resolve(route: ActivatedRouteSnapshot): Observable<PublicInfo> {
    let urlSlug: string = route.params.organization_slug;
    return this.organizationService.getAndStorePublicInfo$(urlSlug).pipe(
      catchError(() => {
        void this.router.navigate(['/404'], { skipLocationChange: true });
        return of();
      })
    );
  }
}
